const React = require('react');

// @ components
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const listItem = require('./listItem');
const { text } = require('components/mortgageRequest/mortgageRequestPanel/mortgageRequestViewProcess/initialValues');

// @ constants
const documentsTypes = require('constants/mortgageRequestDocumentsTypes');
const { DOCUMENTS_STATUS } = require('constants/mortgageRequestHolderData');

const STATES = require('constants/mortgageRequestStates');

const isValidExpendientState = (type, state) => {
    if (type === 'NS') {
        switch (state) {
            case STATES.WAIT_NS:
            case STATES.PEND_TASACION:
            case STATES.TRAMITAR_TAS:
            case STATES.WAIT_DICTAMEN:
            case STATES.ANALISIS_TAS:
            case STATES.APROBADO_RIESGOS:
            case STATES.PROV_FONDOS:
            case STATES.ESPERA_DOC_FIRMA:
            case STATES.ESPERA_ACTA_NOTARIO:
            case STATES.GESTION_FECHA_FIRMA:
            case STATES.PEND_MMPP:
            case STATES.PEND_SALDO:
            case STATES.PEND_FIRMA:
            case STATES.FIRMADO:
                return true;
            default:
                return false;
        }
    }
    if (type === 'TAS') {
        switch (state) {
            case STATES.ANALISIS_TAS:
            case STATES.OFRECER_FINANCIACION_GASTOS:
            case STATES.APROBADO_RIESGOS:
            case STATES.PROV_FONDOS:
            case STATES.ESPERA_DOC_FIRMA:
            case STATES.ESPERA_ACTA_NOTARIO:
            case STATES.GESTION_FECHA_FIRMA:
            case STATES.PEND_MMPP:
            case STATES.PEND_SALDO:
            case STATES.PEND_FIRMA:
            case STATES.FIRMADO:
                return true;
            default:
                return false;
        }
    }
};

const verifyDictamen = (item, inmueblesState, doc) => {
    let ok = false;

    if (item === 'simpleNote') {
        inmueblesState.get('list').map(inmueble => {
            if (inmueble.get('bienId') === doc.get('bienId')) {
                if (inmueble.get('resultadoDictamen') === '1') {
                    ok = true;
                }
            }
        });
    }
    return ok;
};

const checkStatus = (item, data) => {
    let ok = false;

    if (item === 'estates') {
        const cantidadVivienda = data.estatesState.getIn(['ammounts', 'livingPlace'], 0);
        ok = cantidadVivienda === 1;
    }

    if (item === 'simpleNote') {
        if (!isValidExpendientState('NS', data.mortgageState.get('estado'))) {
            return false;
        }

        data.summaryDocumentationState.get('data').map(doc => {

            if (doc.get('tipoDocumentoId', '') === documentsTypes.NS || doc.get('tipoDocumentoId', '') === documentsTypes.NS_CLI) {

                if (doc.get('estado') === DOCUMENTS_STATUS.VERIFICADO && verifyDictamen(item, data.inmueblesState, doc)) {
                    ok = true;
                }
            }
        });
    }

    if (item === 'appraisal') {
        if (!isValidExpendientState('TAS', data.mortgageState.get('estado'))) {
            return false;
        }

        const tasDictEstado = data.summaryDocumentationState.get('data').filter(doc => doc.get('tipoDocumentoId', '') === documentsTypes.TAS_DICT);

        if (tasDictEstado.getIn([0, 'estado'], '') === DOCUMENTS_STATUS.VERIFICADO) {
            data.summaryDocumentationState.get('data').map(doc => {
                if (doc.get('tipoDocumentoId', '') === documentsTypes.TAS || doc.get('tipoDocumentoId', '') === documentsTypes.TAS_CLI) {
                    if (doc.get('estado') === DOCUMENTS_STATUS.VERIFICADO) {
                        ok = true;
                    }
                }
            });
        }
    }

    return ok;
}

const isFetching = (data) => {
    let ok = false;

    if (!data.estatesState.get('ammountsRequested') || data.estatesState.get('isFetching')) {
        ok = true;
    }

    if (!data.summaryDocumentationState.get('documentsRequested') || data.summaryDocumentationState.get('isFetching')) {
        ok = true;
    }

    if (!data.inmueblesState.get('hasBeenFetched') || data.inmueblesState.get('isFetching')) {
        ok = true;
    }

    return ok;
}

const sectionDocumentsLivingPlace = (data) => {

    const list = isFetching(data) ?
        <LoadingSection /> :
        (
            <div>
                {listItem(text().SECTION.LIVING_PLACE.ITEM_ESTATES, checkStatus('estates', data))}
                {listItem(text().SECTION.LIVING_PLACE.ITEM_SIMPLE_NOTE, checkStatus('simpleNote', data))}
                {listItem(text().SECTION.LIVING_PLACE.ITEM_APPRAISAL, checkStatus('appraisal', data))}
            </div>

        );


    return (
        <div className="mortgage-request-view-process__panel-left-section">
            <OKBoxTitle
                value={text().SECTION.LIVING_PLACE.TITLE}
                size="medium"
            />
            {list}

        </div>
    )
}

module.exports = sectionDocumentsLivingPlace;
